import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Tag from '~/modules/addListing/pages/DetailsStep/Tag';
import { addListingDetailsType } from '~addListing/types';

const View = ({
  customFieldsData,
}: {
  customFieldsData: { propertyView: { value: string; key: number }[] };
}) => {
  const [selectedTag, setSelectedTag] = useState<number | null>(null);
  const { t } = useTranslation('app');
  const [propertyView, setPropertyView] = useState<
    { value: string; key: number }[]
  >([]);
  const [showMore, setShowMore] = useState(true);
  const {
    setValue,
    clearErrors,
    watch,
    formState: { errors },
  } = useFormContext<addListingDetailsType>();

  const handleSelectView = (key: number) => {
    setSelectedTag(key);
    setValue('propertyView', key);
    clearErrors('propertyView');
  };

  useEffect(() => {
    setPropertyView(customFieldsData.propertyView.slice(0, 5));
    setSelectedTag(watch('propertyView'));
  }, []);

  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 text-black">{t('view')}</p>
      <div className="flex flex-wrap gap-1.5x">
        {propertyView.map((tag) => (
          <Tag
            key={tag.key}
            text={tag.value}
            isSelected={selectedTag === tag.key}
            onClick={() => handleSelectView(tag.key)}
            className={
              errors.propertyView ? '!border-red_dark' : '!border-gray'
            }
          />
        ))}
        {showMore && (
          <Tag
            text={`+${customFieldsData.propertyView.length - 5} ${t('others')} `}
            onClick={() => {
              setPropertyView(customFieldsData.propertyView);
              setShowMore(false);
              clearErrors('propertyView');
            }}
            isSelected={false}
            className={`!text-blue text-link cursor-pointer ${errors.propertyView ? '!border-red_dark' : '!border-gray'}`}
          />
        )}
      </div>
      {errors.propertyView && (
        <p className="text-red_dark">{t('propertyViewRequired')}</p>
      )}
    </div>
  );
};

export default View;
